import { Box, Tooltip } from '@chakra-ui/react'
import { Icon } from 'iconsax-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import usePlanModules from '@/org/hooks/usePlanModules'
import { Org_Module_Enum } from '@gql'
import SidebarItem from './SidebarItem'

interface Props {
  icon: Icon
  label: string
  /**
   * Le module fermé. La formule à nommer s'en déduit — elle n'est pas passée
   * par l'appelant, qui écrirait « CartoGroov » en dur et le laisserait devenir
   * faux le jour où un module change de formule.
   */
  module: Org_Module_Enum
  /** L'organisation est désactivée : aucune formule n'ouvrira quoi que ce soit. */
  isOrgDisabled?: boolean
}

/**
 * Une entrée de menu **visible mais fermée** (ADM-D9).
 *
 * 🔑 **Griser, jamais cacher.** Faire disparaître les modules absents du forfait
 * priverait Yohan de tout levier commercial : personne ne demande ce qu'il ne
 * voit pas. L'entrée reste donc là, éteinte, et nomme la formule qui l'ouvre —
 * c'est une vitrine, pas une punition.
 */
export default function SidebarItemLocked({
  icon,
  label,
  module,
  isOrgDisabled,
}: Props) {
  const { t } = useTranslation()
  const planModules = usePlanModules()

  // La formule à nommer vient de la règle EN BASE (ADM06-D5), plus d'une
  // constante : le jour où un module change de forfait, l'infobulle suit sans
  // qu'on y touche.
  const unlockedBy = isOrgDisabled ? undefined : planModules.unlockedBy(module)

  return (
    <Tooltip
      label={
        unlockedBy
          ? t('Sidebar.locked.plan', { plan: unlockedBy })
          : t('Sidebar.locked.disabled')
      }
      placement="right"
      hasArrow
      openDelay={200}
    >
      {/* Un porteur d'événements : Tooltip a besoin d'un enfant qui en
          reçoive, or un bouton désactivé n'en émet aucun. Un Box et non un
          span nu — inline, il aurait rétréci l'entrée par rapport à ses
          voisines malgré le w=100% du bouton. */}
      <Box w="100%">
        <SidebarItem
          icon={icon}
          isDisabled
          opacity={0.45}
          cursor="not-allowed"
          _hover={{}}
          w="100%"
        >
          {label}
        </SidebarItem>
      </Box>
    </Tooltip>
  )
}
